import { API, DataStore, graphqlOperation } from 'aws-amplify'
import { Profile } from '@/models'
import { listProfiles } from '@/graphql/queries'

export default {
  'profile.get': async ({ commit }, username) => {
    console.log('find profile;', username)
    try {
      const profiles = (await API.graphql(graphqlOperation(listProfiles))).data.listProfiles.items
      console.log(profiles)
      const profile = profiles.find(i => i.username === username)
      if (profile) {
        commit('profile.set', profile)
      }
      return profile
    } catch (e) {
      console.warn(e)
    }
  },
  'profile.create': async ({ commit }, input) => {
    try {
      const profile = await DataStore.save(new Profile(input))
      if (profile) {
        commit('profile.set', profile)
      }
      return profile
    } catch (e) {
      console.warn(e)
    }
  }
}
